import { render } from "./SupernaturalEventModal.vue?vue&type=template&id=0ed9161c&scoped=true"
import script from "./SupernaturalEventModal.vue?vue&type=script&lang=js"
export * from "./SupernaturalEventModal.vue?vue&type=script&lang=js"

import "./SupernaturalEventModal.vue?vue&type=style&index=0&id=0ed9161c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed9161c"]])

export default __exports__